// Radio-style template type: a template is exactly one of these three.
// Backend keeps two independent booleans on ReportTemplate — this module
// is the single conversion point so mutation payloads and edit-state
// stay in sync. UpdateTemplate on api-django rejects (base=true, ent=true).
export type TemplateType = "base" | "enterprise" | "self_service";

export const templateTypeFromFlags = (isBase: boolean, isEnterprise: boolean): TemplateType => {
  if (isBase) return "base";
  if (isEnterprise) return "enterprise";
  return "self_service";
};

export const flagsFromTemplateType = (
  t: TemplateType,
): { is_base_template: boolean; enterprise_template: boolean } => ({
  is_base_template: t === "base",
  enterprise_template: t === "enterprise",
});

export const TEMPLATE_TYPE_LABEL: Record<TemplateType, string> = {
  base: "Base Template",
  enterprise: "Enterprise Template",
  self_service: "Self-Service Template",
};
